import React, { useState } from "react";

interface FieldErrorDictionary {
    [fieldName: string]: boolean;
}

export default function useFormContext(formRef: React.RefObject<HTMLFormElement>): IFormContext {
    const [errors, setErrors] = useState<FieldErrorDictionary>({});
    const [isValidated, setIsValidated] = useState(false);

    function validate(): boolean {
        setIsValidated(true);
        const isValid = Object.values(errors).filter(isValid => !isValid).length === 0;
        return isValid && formRef.current.checkValidity();
    }

    function setField(fieldName: string, isValid: boolean) {
        setErrors(prev => ({ ...prev, [fieldName]: isValid }));
    }

    function reset(): void {
        setErrors({});
        setIsValidated(false);
    }

    return {
        isValidated: isValidated,
        validate: validate,
        setField: setField,
        reset: reset,
    }
}

interface IFormContext {
    isValidated: boolean;
    validate(): boolean;
    setField(fieldName: string, isValid: boolean): unknown;
    reset(): void;
}

export const FormContext = React.createContext<IFormContext>({
    isValidated: false,
    setField: () => { },
    validate: () => true,
    reset: () => { },
});